import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Tabs from "../../../components/PPA/Tabs/Tabs";
import PPAContext from "../../../contexts/PPA/PPAContext";

export default function PPAValuation() {
  const location = useLocation();
  const {
    getValuationDetails,
    SetFormData,
    SetActiveTabId,
    SetResultData,
    setScenarioResults,
  } = useContext(PPAContext);

  useEffect(() => {
    if (location.state?.id) {
      getValuationDetails(location.state?.id, location?.state?.mode);
    }
    return () => {
      if (location.state?.id) {
        console.log("Resetting the valuation input and output *****");
        SetFormData({});
        SetResultData({});
        SetActiveTabId("1");
        setScenarioResults([]);
      }
    };
  }, [location.state?.id]);

  return <Tabs />;
}
